<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- payment -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="DollarSignIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Pagos</span>
      </template>

      <account-setting-payment />
    </b-tab>

    <!-- general tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">General</span>
      </template>

      <!-- El `v-if="options.general"` que había acá es por qué la pestaña salía
           en blanco: `options` se llenaba con `GET /account-setting/data`, un
           endpoint de la demo de Vuexy que en esta API no existe, así que la
           condición nunca se cumplía. El componente igual no usaba esos datos:
           se trae los suyos de `/user/{id}` en su `created()`. -->
      <account-setting-general />
    </b-tab>
    <!--/ general tab -->

    <!-- notification -->
    <b-tab v-if="valid">
      <!-- title -->
      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Cotización</span>
      </template>

      <account-setting-currency-price />
    </b-tab>
  </b-tabs>
</template>

<script>
import usePermission from "@/views/js/usePermission"
import { BTab, BTabs } from "bootstrap-vue"
import AccountSettingCurrencyPrice from "./AccountSettingCurrencyPrice.vue"
import AccountSettingGeneral from "./AccountSettingGeneral.vue"
import AccountSettingPayment from "./AccountSettingPayment.vue"

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPayment,
    AccountSettingCurrencyPrice,
  },
  setup() {
    const { valid } = usePermission(1)

    return { valid }
  },
}
</script>
